import { BaseService } from "@/services/BaseService";
import type {
  EmailTemplateTrigger,
  HotelEmailTemplate,
  PreviewHotelEmailTemplatePayload,
  RenderedHotelEmailTemplate,
  UpsertHotelEmailTemplatePayload,
} from "@/types/hotel-email-template";

class HotelEmailTemplateService extends BaseService {
  private buildPath(hotelId: string): string {
    return `/hotels/${hotelId}/email-templates`;
  }

  list(hotelId: string): Promise<HotelEmailTemplate[]> {
    return this.get<HotelEmailTemplate[]>(this.buildPath(hotelId));
  }

  upsertByTrigger(
    hotelId: string,
    trigger: EmailTemplateTrigger,
    payload: UpsertHotelEmailTemplatePayload,
  ): Promise<HotelEmailTemplate> {
    return this.put<HotelEmailTemplate>(
      `${this.buildPath(hotelId)}/triggers/${trigger}`,
      payload,
    );
  }

  deleteTemplate(hotelId: string, templateId: string): Promise<void> {
    return super.delete<void>(`${this.buildPath(hotelId)}/${templateId}`);
  }

  previewUnsaved(
    hotelId: string,
    payload: PreviewHotelEmailTemplatePayload,
  ): Promise<RenderedHotelEmailTemplate> {
    return this.post<RenderedHotelEmailTemplate>(
      `${this.buildPath(hotelId)}/preview`,
      payload,
    );
  }
}

export const hotelEmailTemplateService = new HotelEmailTemplateService();
